import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yoko/renehuemer.com/website/src/app/art/blog-client.tsx");
